import { render } from "./index.vue?vue&type=template&id=f143b334&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f143b334&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f143b334"

export default script